import { CarrierSharingService } from '../../store/carrier-sharing/carrier-sharing-service';
import { useIsVendorOr3PL } from '../../hooks/use-is-vendor-or-3pl';
import useSelectedItemName from './use-selected-item-name';

const useSelectedServiceName = (selectedServiceItem, selectedServiceId, sharedByPartnerServices) => {
  const isVendorOr3PL = useIsVendorOr3PL();
  const itemName = useSelectedItemName(selectedServiceItem);

  if (!isVendorOr3PL) {
    return itemName;
  }

  return CarrierSharingService.selectedServiceName(
    selectedServiceId,
    itemName,
    sharedByPartnerServices,
    selectedServiceItem.sellerLabelProviderId,
  );
};

export default useSelectedServiceName;
